export enum Difficulty {
  Easy,
  Normal,
  Hard,
  Expert,
  Insane
}
